import script from "./renderPost.vue?vue&type=script&lang=js"
export * from "./renderPost.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__